import React from 'react'
import { Link } from 'react-router-dom'
import { Popconfirm, message } from 'antd'
import {
  Div, H4, Button,
} from 'konsys-ui'
import { Query, Mutation } from 'react-apollo'
import PATH from '../../../constants/path'
import {
  NewButton, ButtonAction,
  SimpleTable, ActionGroupWrapper,
  Column,
} from './styled'
import { theme } from '../../../styles/_variables'
import { DELETE_SPOT_UV } from '../../../constants/graphql/mutation'
import { LIST_SPOT_UV } from '../../../constants/graphql/query'
import RecommendationSetting from '../recommendation-setting'
import BreadCrumb from '../../../components/common/breadcrumb'


const { color } = theme

const columns = [
  {
    title: 'วิธีการเคลือบ',
    dataIndex: 'name',
    render: text => <Column>{text}</Column>,
    align: 'center',
  },
  {
    title: 'คำสั่ง',
    dataIndex: 'action',
    align: 'center',
    width: '120px',
  },
]

const SpotUVSetting = props => (
  <Div>
    <Div display='flex' flexDirection='row' justifyContent='space-between' margin='32px 0px 0px 0px' alignItems='center'>
      <Div display='flex' flexDirection='column'>
      <H4 bold color={color.primaryColor}>
          <Link to='/package-setting' style={{ alignSelf: 'flex-end', cursor: 'pointer' }} >
            <H4 bold color={color.primaryColor}>Catalog Settings</H4>
          </Link> {' > '} การเคลือบยูวีเฉพาะจุด
        </H4>
      </Div>
      <Link to='/package-setting/spot-uv-create' style={{ alignSelf: 'flex-end', cursor: 'pointer' }} >
        <Button
          htmlType="submit"
          text='New'
          icon='fal fa-plus'
          inverse
        />
      </Link>
    </Div>
    <TableListSpotUV history={props.history} />
  </Div>
)

const TableListSpotUV = ({
  history,
}) => (
  <Div>
    <Query
      query={LIST_SPOT_UV}
      fetchPolicy='cache-and-network'
      variables={{
        limit: 10000,
        offset: 0,
      }}
    >
      {
        ({ loading, data, refetch }) => {
          let spotUVList = []
          let spotUVRemark = null
          if (!loading) {
            spotUVList = data.listSpotUV.spotUV.map(item => ({
              name: item.name,
              action: <ActionGroup rowData={item} onEdit={() => history.push(`${PATH.spotUVDetail}/${item.spotUVId}`)}/>,
            }))
            spotUVRemark = data.listSpotUV.remark
          }
          return (
          <>
            <RecommendationSetting
              moduleName='spot_uv'
              data={spotUVRemark}
              refetch={() => refetch()}
            />
            <SimpleTable
              loading={loading}
              columns={columns}
              dataSource={spotUVList}
              pagination={false}
            />
          </>
          )
        }
      }
    </Query>
  </Div>
)

const ActionGroup = ({ rowData, onEdit }) => (
  <ActionGroupWrapper>
    <ButtonAction small inverse text='แก้ไข' icon='fa fa-pencil-square-o' onClick={onEdit} />
    <Mutation mutation={DELETE_SPOT_UV}>
      {
        doDeleteSpotUV => (
          <Popconfirm
            title='ยืนยันการรลบการเคลือบยูวีเฉพาะจุดหรือไม่ หากลบแล้วจะไม่สามารถเรียกคืนได้อีก'
            onConfirm={() => {
              doDeleteSpotUV({
                variables: {
                  id: parseInt(rowData.spotUVId, 10),
                },
              }).then((res) => {
                if (res.data.deleteSpotUV) {
                  if (res.data.deleteSpotUV.success) {
                    message.success(res.data.deleteSpotUV.message)
                    setTimeout(() => {
                      window.location = PATH.spotUVSetting
                    }, 100)
                  } else {
                    message.error(res.data.deleteSpotUV.message)
                  }
                }
              })
            }}
            okText='ยืนยัน'
            cancelText='ยกเลิก'
          >
            <ButtonAction small text='ลบ' icon='fa fa-trash-o fa-lg' color={theme.color.error} />
          </Popconfirm>
        )
      }
    </Mutation>
  </ActionGroupWrapper>
)

export default SpotUVSetting
